<template>
    <div>
        <Title title="新闻" :path="formPath"/>

        <div class="page-loading" v-if="init === true">
            <van-skeleton title :row="8" />
        </div>
        <div class="main newsview" v-else>
            <template v-if="news">
                <h1>{{ news.title }}</h1>
                <div class="time">时间：{{ news.time }} &nbsp;&nbsp;&nbsp;&nbsp;来源：网络</div>
                <div class="content" v-html="news.content"></div>
                <div class="next">
                    <p v-if="news_prev">上一篇：<router-link :to="'/news/v/'+news_prev.id">{{ news_prev.title }}</router-link></p>
                    <p v-if="news_next">下一篇：<router-link :to="'/news/v/'+news_next.id">{{ news_next.title }}</router-link></p>
                </div>
            </template>
            <el-empty v-else description="找不到内容~"/>
        </div>

    </div>
</template>

<script>
    import Title from './../components/public/title'
    import "../assets/css/news.css"
    export default {
        name: "index",
        components: {
            Title
        },
        watch: {
            '$route': {
                handler (router) {
                    // console.log(router)
                    this.id = router.params.id
                    this.init = true
                    this.getData()
                }
            }
        },
        data() {
            return {
                id: 0,
                init: true,
                news: null,
                news_prev: null,
                news_next: null,
                formPath: ''
            }
        },
        activated() {
            // console.log(this.$route)
            let id = this.$route.params.id
            this.id = id
            this.getData()
        },
        methods: {
            getData(){
                let that = this
                that.$get(that.$api.news_info, {id: that.id}).then(function (res) {
                    // console.log(res.data)
                    if(res.code === 1){
                        if(res.data.news.isturn){
                            location.href = res.data.news.turnUrl
                            return
                        }
                        that.news = null
                        that.news_prev = null
                        that.news_next = null

                        that.news = res.data.news
                        if(res.data.news_prev)
                            that.news_prev = res.data.news_prev
                        if(res.data.news_next)
                            that.news_next = res.data.news_next
                        that.backTop()
                    }
                    that.init = false
                }).finally(function () {
                    that.init = false
                })
            },
            backTop(){
                var timer = setInterval(function(){
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 2);
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if(osTop === 0){
                        clearInterval(timer);
                    }
                },30)
            },
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
</style>
